// Notifications push (bureau) du Dashboard admin — API Web Notifications.
// Permet d'afficher une notification système quand une nouvelle notification admin
// arrive (nouveaux chauffeurs, paiements, etc.), même si l'onglet est en arrière-plan.

export const pushSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window;

// 'granted' | 'denied' | 'default' | 'unsupported'
export const getPushPermission = () =>
  (pushSupported() ? Notification.permission : 'unsupported');

// Demande la permission à l'utilisateur (doit être déclenché par un geste utilisateur).
export const requestPushPermission = async () => {
  if (!pushSupported()) return 'unsupported';
  try {
    return await Notification.requestPermission();
  } catch (_) {
    return Notification.permission;
  }
};

// Affiche une notification bureau (silencieux si non autorisé).
export const showDesktopNotification = (title, options = {}) => {
  if (!pushSupported() || Notification.permission !== 'granted') return null;
  try {
    const n = new Notification(title, { icon: '/logo192.png', badge: '/logo192.png', ...options });
    n.onclick = () => { try { window.focus(); n.close(); } catch (_) {} };
    return n;
  } catch (_) {
    return null;
  }
};
